import { useParams } from 'react-router';
import { useDataRequestSimple } from '@vivli/features/data-requests/infrastructure/hook';
import { PublishingContentComponent } from '@vivli/features/data-requests/components';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

export const PublishApprovedPreviewComponent = () => {
    const { requestId } = useParams();
    const { dataRequest } = useDataRequestSimple(requestId);
    const { hasPermission } = useActiveUserContext();
    //TODO PERMFE - redo with permissions+
    if (dataRequest && hasPermission(PermissionsEnum.DrActAdv)) {
        return (
            <PublishingContentComponent
                dataRequest={dataRequest}
                isConfigMode={false}
                arrayNameStudies={null}
                fieldsStudies={null}
                arrayNameDisclosures={null}
                fieldsDisclosures={null}
            />
        );
    }
};
